class youtubePlayer {
    constructor(container) {
        this.container = container;

        const options = window.glxYoutubePlayerConfig || {};

        const el = this.container.querySelector('.js-player-element');

        const template = document.createElement('DIV');
        template.innerHTML = el.querySelector('[type="text/template"]').innerHTML;

        const src = new URL(template.querySelector('iframe').src);
        const videoId = src.pathname.split('embed/')[1];

        this.state = false;

        if (!videoId) return;

        this.player = new YT.Player(el, {
            videoId,
            playerVars: { 
                mute: 1,
                controls: 0,
                disablekb: 1
            },
            events: {
                'onReady': event => {
                    setTimeout(() => {
                        this.state = 'play';

                        event.target.seekTo(localStorage.getItem(`${this.container.id}-time`) || 0, true);

                        this.toggleElements();
                    }, options.delay);
                },
                'onStateChange': event => {
                    if (event.data === 0) {
                        this.state = 'finish';

                        this.toggleElements();

                        this.storeCurrentDuration(0);

                        this.container.hidden = true;
                    }
                }
            }
        });

        this.container.addEventListener('click', () => {
            if(this.player.getPlayerState() == '1') this.state = 'pause'
            else this.state = 'play';

            this.handleControlPlayer();
        });
    }

    handleControlPlayer () {
        if (this.state == 'play') this.player.playVideo();
        else {
            this.player.stopVideo();

            this.storeCurrentDuration(this.player.getCurrentTime());
        }
    
        this.toggleElements();
    }

    toggleElements () {
        document.querySelectorAll('.js-player-dynamic-elements').forEach(element => {
            element.hidden = this.state == 'play';
        });
    }

    storeCurrentDuration (duration) {
        localStorage.setItem(`${this.container.id}-time`, duration);
    }
}


export default () => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);

    window.onYouTubePlayerAPIReady = () => {        
		document.querySelectorAll('.js-player-container').forEach(container => {
            new youtubePlayer(container)
		});
	}
};


// WEBPACK FOOTER //
// ../src/js/modules/youtube-player.js